import React from 'react';
import Button, { ButtonSizes, ButtonThemes } from 'ui-components/button/button';

interface ActionSectionProps {
    handleClear: () => void;
    handleSave: () => void;
    primaryButtonText?: string,
    secondaryButtonText?: string,
    spinner?: boolean,
    className?: string,
    disabled?: boolean,
}

const ActionSection: React.FC<ActionSectionProps> = ({
    handleClear,
    handleSave,
    primaryButtonText = "Save",
    secondaryButtonText = "Clear",
    className,
    disabled,
    ...props
}) => {
    return (
        <div className={"form-action"}>
            <Button
                type="button"
                theme={ButtonThemes.gray}
                onClick={handleClear}
                className={className + " mr-05"}
                size={ButtonSizes.small}
                {...props}>
                {secondaryButtonText}
            </Button>
            <Button
                type="submit"
                theme={ButtonThemes.blue}
                onClick={handleSave}
                className={className}
                size={ButtonSizes.small}
                disabled={disabled}
                {...props}
            >
                {primaryButtonText}
            </Button>
        </div>

    );
};

export default ActionSection;
